/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

(async function() {
  const resp = await fetch("https://c.vedix.com/avatars/pixel.png");
  const headers = resp.headers;
  let country = headers.get("Cloudfront-Viewer-Country").toLowerCase();
  console.log(country);      
  $('body').attr('data-currentcountry',country);
  
  $.getJSON('/cart.js', function(cart){
    if($('body').attr('data-currentcountry') != 'in'){
     console.log(cart) 
      if(cart.item_count > 30){
        console.log($('#checkout2').length)
        $('#checkout2').attr('disabled','disabled').removeAttr('onclick');
      }else{
        $('#checkout2').removeAttr('disabled').attr('onclick','handleFloCheckoutBtn()');
      }
    }
  }); 
  
})();

window.addEventListener('load', function() {
  function initSwat() {
    if (window._swat && _swat.collectionsApi && typeof _swat.collectionsApi.initializeCollections === 'function') {
      console.log('wishlist icon added from custom.js');
      _swat.collectionsApi.initializeCollections(_swat, true, Shopify.theme.schema_name);
    } else {
      setTimeout(initSwat, 200); // check again after 200ms
    }
  }
  initSwat();
});


$(document).ready(function(){

  if(window.location.hash.indexOf('#opencartdrawer') > -1) {
    document.getElementById('mini-cart').open = true;
    const url = window.location.href.replace("#opencartdrawer", "");
    history.replaceState(null, null, url);
  }
  
  $('.featured-product-list_grid.slider').each(function() {
    
    var desktopSlidesToShow = parseInt($(this).attr('desktop_per_row'));
    var mobileSlidesToShow = parseInt($(this).attr('mobile_per_row'));
    
    $(this).slick({
      dots: true,
      slidesToShow: desktopSlidesToShow,
      slidesToScroll: 1,
      infinite: false,
      focusOnSelect: false,
      accesibility: false,
      draggable: false,
      swipe: false,
      touchMove: false,
      responsive: [
        {
           breakpoint: 740,
           settings: "unslick"
        }
       ]
    });
  });
  
  $('.category-list_row').slick({
    dots: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    infinite: false,
    responsive: [
      {
        breakpoint: 999,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 740,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });
  $('.testimonial-custom_row').slick({
    dots: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: false,
  });

  $('.stl-product-list_row').slick({
    dots: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: false,
    responsive: [
      {
         breakpoint: 740,
         settings: "unslick"
      }
   ]
  });

  $('.product-meta--image_list').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    infinite: true,
    dots: false,
    arrows: false
  });

  var timer_date = $('#mini-cart').attr('timer-date');
  var countDownDate = new Date(`${timer_date}`).getTime();
  var x = setInterval(function() {
    var now = new Date().getTime();
  
    var distance = countDownDate - now;
  
    var days = Math.floor(distance / (1000 * 60 * 60 * 24));
    var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    var seconds = Math.floor((distance % (1000 * 60)) / 1000);
  
    // document.getElementById("sale_timer_alert").innerHTML = `
    //   <span class="at-item_count">${days}d:</span>
    //   <span class="at-item_count">${hours}h:</span>
    //   <span class="at-item_count">${minutes}m:</span>
    //   <span class="at-item_count">${seconds}s</span>
    // `;
    var timerHTML = "";

    if (days > 0) {
      timerHTML += `<span class="at-item_count">${days}d:&nbsp;</span>`;
    }
    if (hours > 0 || days > 0) { 
      timerHTML += `<span class="at-item_count">${hours}h:&nbsp;</span>`;
    }
    if (minutes > 0 || hours > 0 || days > 0) { 
      timerHTML += `<span class="at-item_count">${minutes}m:&nbsp;</span>`;
    }
    if (seconds > 0 || minutes > 0 || hours > 0 || days > 0) { 
      timerHTML += `<span class="at-item_count">${seconds}s</span>`;
    }
    // console.log('000',document.getElementById("sale_timer_alert"));
    if($('body #sale_timer_alert').length > 0){
      $("body #sale_timer_alert").html(timerHTML);
    
      if (distance < 0) {
        clearInterval(x);
        $("body #sale_timer_alert").html('EXPIRED');
        $("body .product-sale-timer-wrap").addClass('remove');
      }
    }
  }, 1000);

  //STORE LOCATOR
  $('body').on('change','#OutletState', function(){   
    var current_selected_state = $(this).val();
    console.log('current_selected_state',current_selected_state,);
    if(current_selected_state == ''){
      $(this).parents('.sl--filter--header_main').find('.sl--filter-item-city').find(`option:first-child`).attr("state", 'all');
      $('#OutletCity').val('').trigger('change');
      $(this).parents('.sl--filter--header_main').find('.sl--filter-item-city').find(`option`).show();
    }else{
      $(this).parents('.sl--filter--header_main').find('.sl--filter-item-city').find(`option:first-child`).attr("state", current_selected_state);
      console.log($($(this).parents('.sl--filter--header_main').find('.sl--filter-item-city').find(`option[state="${current_selected_state}"]`)[0]).attr('value'));
      $('#OutletCity').val($($(this).parents('.sl--filter--header_main').find('.sl--filter-item-city').find(`option[state="${current_selected_state}"]`)[0]).attr('value')).trigger('change');
      $(this).parents('.sl--filter--header_main').find('.sl--filter-item-city').find(`option[state="${current_selected_state}"]`).show();
      $(this).parents('.sl--filter--header_main').find('.sl--filter-item-city').find(`option:not([state="${current_selected_state}"])`).hide();
    }
  });
  
   $('body').on('click','.search_submit_filter', function(){    
    var state = '', city = '',locality = '';
    if($(this).closest('.sl--filter-row').find('[name="state"]').length > 0){
      state = $(this).closest('.sl--filter-row').find('[name="state"]').val();  
    }
    if($(this).closest('.sl--filter-row').find('[name="city"]').length > 0){
      city = $(this).closest('.sl--filter-row').find('[name="city"]').val();  
    }
    if($(this).closest('.sl--filter-row').find('[name="locality"]').length > 0){
      locality = $(this).closest('.sl--filter-row').find('[name="locality"]').val();  
    }
    var mergeval = state + city + locality;
    var spaceremoved = mergeval.replaceAll(' ','');        
    var cnt = 0;
    if(spaceremoved != ''){
      $(".stor-locator-grid-item").filter(function() {
        $(this).toggle($(this).attr('data-serachval').indexOf(spaceremoved) > -1);
        if($(this).attr('data-serachval').indexOf(spaceremoved) > -1){
          cnt++;
        }
      });
      if(cnt == 0){
        $('.stor-locator-result').hide();
        $('.stor-locator-noresult').removeAttr('hidden');
      }else{
        $('.stor-locator-result').show();
        $('.stor-locator-noresult').attr('hidden', true);
      } 
    }else{
      $(".stor-locator-grid-item").show();
      $('.stor-locator-result').show();
      $('.stor-locator-noresult').attr('hidden', true);
    }   
  });

  $("body").on("click", ".product-offer_item-code_copy", function () {
    var copy_text = $(this);
    var text = $(this).attr('coupon');
    var $temp = $("<input>");
      
    $("body").append($temp);
    $temp.val(text).select();
    document.execCommand("copy");
    $temp.remove();
    copy_text.attr("copied","copied")
      
    setTimeout(function () {
      copy_text.removeAttr("copied");
    }, 1000);
  });

  $('body').on('click', '.product-list_grid-view', function(e) {
    e.preventDefault();
    $('.product-list_grid-view').removeClass('active');
    $(this).addClass('active');
    $("product-list").attr("list-type", $(this).attr('href'));
    console.log($(this).attr('href'));
  });

  // Initialize original values as data attributes
  $(".size-chart-item_content table tbody tr").each(function () {
    $(this).find("td").each(function (index) {
      const value = parseFloat($(this).text().trim());
      if (!isNaN(value)) {
        $(this).attr("data-in", value); // Store original IN values
        $(this).attr("data-cm", (value * 2.54).toFixed(0)); // Store converted CM values
      }
    });
  });

  // Handle unit conversion on click
  $('body').on('click', '.size-chart-converter_item', function() {    
    // Update active class
    $(this).parents('.size-chart-item').find(".size-chart-converter_item").removeClass("active");
    $(this).addClass("active");

    // Determine the selected unit
    const unit = $(this).data("type"); // CM or IN

    // Update table values dynamically
    $(this).parents('.size-chart-item').find("table tbody tr").each(function () {
      $(this).find("td:not(:first-child)").each(function () {
        if (unit === "CM") {
          $(this).text($(this).data("cm")); // Show CM values
        } else {
          $(this).text($(this).data("in")); // Show IN values
        }
      });
    });
  });
  
  document.addEventListener('cart:refresh', function(event) {
    var cart = event.detail.cart; // Get the updated content of the cart
    if($('body').attr('data-currentcountry') != 'in'){
     console.log(cart) 
      if(cart.item_count > 10){
        console.log($('#checkout2').length)
        $('#checkout2').attr('disabled','disabled').removeAttr('onclick');
      }else{
        $('#checkout2').removeAttr('disabled').attr('onclick','handleFloCheckoutBtn()');
      }
    }
  });

  
  $('body').on('click', '.bundle_item_form .block-swatch__radio', function() {
    const value = $(this).attr('data-value');
    const $picker = $(this).closest('.product-form__option-selector');
    
    $picker.next().find('.block-swatch__radio[data-value="' + value + '"]').not(this).trigger('click');
  });
  
  $('body').on('change', '.product-sticky-form__form select[data-option-position="1"]', function() {
    console.log('jjijijiji');
    const value = $(this).find('option:selected').text();
    const $picker = $(this).closest('.product-sticky-form__form');
    console.log(value);
    $picker.find('.combo-box__option-item[data-value="'+value+'"]').trigger('click');
  });

  if ($(window).scrollTop() > 1000) {
    $('.go-top').addClass('show');
  } else {
    $('.go-top').removeClass('show');
  }

  $('.go-top').on('click', function (e) {
    e.preventDefault();
    $('html, body').animate({ scrollTop: 0 }, 600); // 600 = speed in ms
  });

  $('.collection-desc-readmore').click(function(e){
    e.preventDefault();
    $('.collection-seo_default-content').hide();
    $('.collection-seo_readmore-content').show();
  });
  $('.collection-desc-readless').click(function(e){
    e.preventDefault();
    $('.collection-seo_default-content').show();
    $('.collection-seo_readmore-content').hide();
  });

  $('body').on('click','.careers .job_details_toggle', function(e){
    console.log('innnn')
    if ($(e.target).closest('a, button').length) return;
    $(this).find('.tab_content[data-tab="'+$(this).attr('data-tab')+'"]').slideToggle();
  });

  $('body').on('click','.careers .tab_button', function(e){
    e.stopPropagation();
    $(this).closest('.job-item').find('.tab_content').not('[data-tab="'+$(this).attr('data-tab')+'"]').slideUp();
    $(this).closest('.job-item').find('.tab_content[data-tab="'+$(this).attr('data-tab')+'"]').slideToggle();
  });

  $('body').on('click','.careers .form_model_button', function(e){
    $('.form_popup_model,.form_model_overlay').addClass('active');
  });

  $('body').on('click','.form_popup_model .close_buttonwp', function(e){
    $('.form_popup_model,.form_model_overlay').removeClass('active');
  });

  // PRODUCT ITEM SWATCH
  $('body').on('click','.product-item-color-option', function(e) {
    var _this = this;
    e.preventDefault();
    var product_handle = $(this).attr("product_handle");
    var $main = $(_this).closest(".product-item-main");
    $main.addClass('selected-swatch-loading');
    $.ajax({
      type: 'GET',
      url: `/products/${product_handle}?view=product-item`, // replace with your Shopify endpoint
      success: function(data) {
        $main.removeClass('selected-swatch-loading');
        var doc = new DOMParser().parseFromString(data, 'text/html');
        var newImg = doc.querySelector('.product-item__primary-image');
        var $oldImg = $main.find('.product-item__primary-image');
        if (newImg && $oldImg.length) {
          $oldImg.attr('src', newImg.getAttribute('src'));
          $oldImg.attr('srcset', newImg.getAttribute('srcset') || '');
        }
        var newSecImg = doc.querySelector('.product-item__secondary-image');
        var $oldSecImg = $main.find('.product-item__secondary-image');
        if (newSecImg && $oldSecImg.length) {
          $oldSecImg.attr('src', newSecImg.getAttribute('src'));
          $oldSecImg.attr('srcset', newSecImg.getAttribute('srcset') || '');
        }
        var newLink = doc.querySelector('.product-item-meta__title');
        if (newLink) {
          var newUrl = newLink.getAttribute('href');
          $main.find('.product-item__aspect-ratio, .product-item-meta__title').attr('href', newUrl);

          // Quick view: swap in fresh drawer/popover pointing to the selected colour product
          $main.find('quick-buy-drawer, quick-buy-popover').each(function() {
            var $fresh = $(this.cloneNode(false)).attr('href', newUrl).removeAttr('open');
            $(this).replaceWith($fresh);
          });
        }

        // Single-variant quick add: point the form to the selected colour product's variant
        var newVariantInput = doc.querySelector('.product-item__quick-form input[name="id"], .product-item__cta-wrapper input[name="id"]');
        if (newVariantInput) {
          $main.find('.product-item__quick-form input[name="id"], .product-item__cta-wrapper input[name="id"]').val(newVariantInput.value);
        }
        var newPrice = doc.querySelector('.product-item-meta__price-list-container');
        var $oldPrice = $main.find('.product-item-meta__price-list-container');
        if (newPrice && $oldPrice.length) {
          $oldPrice.html(newPrice.innerHTML);
        }
        var newWishlist = doc.querySelector('.iWishAddColl');
        var $oldWishlist = $main.find('.iWishAddColl');
        if (newWishlist && $oldWishlist.length) {          
          $oldWishlist
            .attr('data-variant', newWishlist.getAttribute('data-variant'))
            .attr('data-product', newWishlist.getAttribute('data-product'))
            .attr('data-pttitle', newWishlist.getAttribute('data-pttitle'))
            .attr('href', newWishlist.getAttribute('href'))
            .removeAttr('data-iwclick');
        }
        $(_this).siblings('.product-item-color-option').removeClass('is-active');        
        $(_this).addClass('is-active');
        if (window._swat && _swat.collectionsApi && typeof _swat.collectionsApi.initializeCollections === 'function') {
          _swat.collectionsApi.initializeCollections(_swat, true, Shopify.theme.schema_name);
        }
      },
      error: function(xhr, status, error) {
        $main.removeClass('selected-swatch-loading');
        console.error('AJAX error:', status, error);
      }
    });
  })

  $('.rm-content-text').click(function(e) {
    e.preventDefault();
    $('.rm-content_wrapper').toggleClass('active');
    if ($('.rm-content-text').text() == "Read more") {
      $(this).text("Read less")
    } else {
      $(this).text("Read more")
    }
  });
  
});

$(function () {
  $(document).on('click', '.selection-round-tab-item', function () {
    var $btn = $(this);
    var $section = $btn.closest('.selection-round-tab-section');
    var tab = $btn.data('tab');

    $section.find('.selection-round-tab-item').removeClass('is-active').attr('aria-selected', 'false');
    $btn.addClass('is-active').attr('aria-selected', 'true');

    $section.find('.selection-round-tab-panel').attr('hidden', true)
      .filter('[data-tab="' + tab + '"]').removeAttr('hidden');
  });

  // Theme editor: switch to the tab of the selected block
  $(document).on('shopify:block:select', function (e) {
    var $panel = $(e.target).closest('.selection-round-tab-panel');
    if (!$panel.length) return;

    $panel.closest('.selection-round-tab-section')
      .find('.selection-round-tab-item[data-tab="' + $panel.data('tab') + '"]')
      .trigger('click');
  });
});

$(window).on('scroll resize', function () {
  if ($(window).scrollTop() > 1000) {
    $('.go-top').addClass('show');
  } else {
    $('.go-top').removeClass('show');
  }
});

if($('body').hasClass('template-collection') || $('body').hasClass('template-collection-inner') || $('body').hasClass('template-search') || $('body').hasClass('template-collection-sale')){
  console.log('test');
  // INFINITE COLLECTION
  var pInfScrLoading = false;
  var pInfScrDelay = 100;
  
  function pInfScrExecute() {
    if( $('product-list.product-facet__product-list').height() - 800 < $(document).scrollTop()) {
      var loadingImage;
      pInfScrNode = $('.product-list__inner.grid_view_custom').find('.more');	        
      // removeing this condition && pInfScrNode.css('display') != 'none'
      if(!pInfScrLoading && pInfScrNode.length > 0) {
        pInfScrURL = $('.product-list__inner.grid_view_custom').find('.more a').attr("href");
        $('.product-list').append('<img src="https://cdn.shopify.com/s/files/1/0683/0476/5103/files/Spinner_1.gif?v=1761724303" class="loading" />');
        $.ajax({
          type: 'GET',
          url: pInfScrURL,
          beforeSend: function() {
            pInfScrLoading = true;
            loadingImage = pInfScrNode.clone().empty().append('');
            loadingImage.insertAfter(pInfScrNode);
            pInfScrNode.hide();
            
            console.log('loading...');
          },
          success: function(data) {
            // remove loading feedback
            pInfScrNode.next().remove();
            var filteredData = $(data).find(".product-list__inner");
            // filteredData.attr('data-gridview',$('.grid_view_selector .view_wp.active').attr('data-gridview'));
            $('.product-list__inner.grid_view_custom').find('.more').before(filteredData.html());
            $('.product-list__inner.grid_view_custom').find('.more:not(:last-child)').remove();
            if(filteredData.find('.more').length > 0){
              $('.product-list__inner.grid_view_custom').find('.more').html(filteredData.find('.more').html());
            }else{
              $('.product-list__inner.grid_view_custom').find('.more').remove();
            }
            
            
            loadingImage.remove();	              
            $('.product-list').find('.loading').remove();
            pInfScrLoading = false;
            document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
          },
          dataType: "html"
        });
      }
    }
  }
  $(document).ready(function () {
    $(window).scroll(function(){
      $.doTimeout( 'scroll', pInfScrDelay, pInfScrExecute);
      // if( $(document).height() - 800 > $(document).scrollTop() + $(window).height() ) {
      if( $('product-list.product-facet__product-list').height() - 800 < $(document).scrollTop()) {
        pInfScrDelay = 0;
      }
    });
  });
}


// $(document).on('change', '#productType', function () {
//   const selectedType = $(this).val();
//   $('.type-inputs-wrapper').hide();
//   $(`.type-inputs-wrapper[data-type="${selectedType}"]`).show();
//   $('.type-inputs-wrapper .input__field').val('');
//   $('.size-chart-calculator_result').hide();
// });

// Reinit content (e.g. new timer/slides) whenever the cart updates,
// but only actually rebuild if the drawer is currently open & visible

function initMiniCartSlider() {
  var $slider = $('.mini-cart-slider_wrapper');
  if ($slider.length === 0) return;

  if ($slider.hasClass('slick-initialized')) {
    $slider.slick('unslick');
  }
  $slider.slick(); // reads settings from data-slick attribute
}

// Rebuild every time the mini-cart drawer opens
document.addEventListener('openable-element:open', function(event) {
  if (event.target.id === 'mini-cart') {
    setTimeout(initMiniCartSlider, 800);
  }
});

// Rebuild when cart content is swapped in (add/update/remove items)
document.addEventListener('cart:refresh', function() {
  setTimeout(initMiniCartSlider, 800);
});

// ALWAYS re-init once the full page (images, scripts, everything) has loaded
window.addEventListener('load', function() {
  setTimeout(initMiniCartSlider, 800);
});